import type { OnDestroy, OnInit } from '@angular/core';
import { Directive, TemplateRef, inject } from '@angular/core';
import { Sidebar } from './sidebar.service';

@Directive({ standalone: true, selector: '[flSidebarHeading]' })
export class SidebarHeadingDirective implements OnInit, OnDestroy {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private sidebar = inject(Sidebar);

  ngOnInit(): void {
    this.sidebar.setHeading(this.templateRef);
  }

  ngOnDestroy(): void {
    this.sidebar.setHeading(undefined);
  }
}
